import React, { useState } from "react";
import { DICHOTOMY_ITEMS, DICHOTOMY_OPTIONS } from "./data.js";

export default function DichotomyStage({ onComplete }) {
  const [index, setIndex] = useState(0);
  const [correctCount, setCorrectCount] = useState(0);
  const [flash, setFlash] = useState(null);

  const current = DICHOTOMY_ITEMS[index];
  const done = index >= DICHOTOMY_ITEMS.length;

  const choose = (value) => {
    const correct = value === current.correct;
    if (correct) setCorrectCount((c) => c + 1);
    setFlash(correct ? "correct" : "off");
    setTimeout(() => {
      setFlash(null);
      setIndex((i) => i + 1);
    }, 650);
  };

  if (done) {
    return (
      <div className="animate-popIn text-center">
        <p className="label-pixel mb-2 text-lime">Sort Complete</p>
        <h2 className="pixel-heading mb-4 text-base text-mist">The Dichotomy</h2>

        <div className="mx-auto mb-6 max-w-sm space-y-2 border-2 border-black bg-ink p-4 text-left text-sm">
          <div className="flex justify-between">
            <span className="text-mist/60">Sorted Correctly</span>
            <span className="text-lime">
              {correctCount}/{DICHOTOMY_ITEMS.length}
            </span>
          </div>
        </div>

        <p className="mx-auto mb-6 max-w-sm text-xs text-mist/60">
          Almost everything that actually disturbs people falls outside their control — and
          almost everything that helps falls inside it. That gap is the whole game.
        </p>

        <button onClick={() => onComplete({ correctCount })} className="btn-magenta">
          BUILD YOUR MORNING SYSTEM ▶
        </button>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-4 flex items-center justify-between font-display text-[9px] text-mist/60">
        <span>THE DICHOTOMY SORT</span>
        <span>
          {index}/{DICHOTOMY_ITEMS.length}
        </span>
      </div>

      <p className="mb-5 text-xs text-mist/60">
        For each one: is it actually yours to work with, or something you can only respond to?
      </p>

      <div
        key={current.id}
        className={`mb-5 border-2 border-black bg-ink p-6 text-center transition-colors ${
          flash === "correct" ? "border-lime shadow-glow-cyan" : flash === "off" ? "border-danger" : ""
        }`}
      >
        <p className="text-sm leading-relaxed text-mist/80">{current.text}</p>
      </div>

      <div className="grid grid-cols-2 gap-3">
        {DICHOTOMY_OPTIONS.map((opt) => (
          <button
            key={opt.id}
            onClick={() => choose(opt.id)}
            className={`border-2 px-3 py-4 font-display text-[9px] uppercase transition-colors ${
              opt.id === "WITHIN"
                ? "border-lime text-lime hover:bg-lime hover:text-ink"
                : "border-mist/40 text-mist/70 hover:border-mist hover:text-mist"
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}
